/* TLR header — assets/tlr-header.js */
(function () {
  class TlrHeader extends HTMLElement {
    connectedCallback() {
      this.rotatePromos();
      this.bindNavHover();
      this.bindDrawer();
      this.bindSearch();
      this.bindCartCount();
    }

    disconnectedCallback() { clearInterval(this._timer); }

    rotatePromos() {
      const rotator = this.querySelector('[data-rotate-interval]');
      if (!rotator) return;
      const items = rotator.querySelectorAll('.tlr-bar__promo');
      if (items.length < 2) return;
      const ms = (parseFloat(rotator.dataset.rotateInterval) || 4) * 1000;
      let i = 0;
      this._timer = setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    }

    /*
      Nav dropdowns are <details>, so click and keyboard already work with no JS. This adds
      hover on top for fine pointers only — on touch the tap should still be what opens it.
    */
    bindNavHover() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      const items = this.querySelectorAll('[data-tlr-nav-drop]');
      items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          items.forEach(other => { if (other !== item) other.open = false; });
          item.open = true;
        });
        item.addEventListener('mouseleave', () => { item.open = false; });
        // Hover already opened the panel, so a mouse click on the parent goes to its
        // landing page (COLLABS → all collabs) instead of toggling the panel shut.
        // detail === 0 means the click came from Enter/Space, which must still toggle.
        const summary = item.querySelector('summary');
        summary.addEventListener('click', e => {
          if (e.detail === 0) return;
          e.preventDefault();
          const href = summary.dataset.tlrHref;
          if (!href) return;
          if (e.metaKey || e.ctrlKey) window.open(href, '_blank');
          else window.location.href = href;
        });
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') items.forEach(item => { item.open = false; });
      });
    }

    bindDrawer() {
      const drawer = this.querySelector('[data-tlr-drawer]');
      const burger = this.querySelector('[data-tlr-drawer-open]');
      if (!drawer || !burger) return;

      const open = () => {
        drawer.hidden = false;
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      };
      const close = () => {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        setTimeout(() => { drawer.hidden = true; }, 320);
      };

      burger.addEventListener('click', open);
      drawer.querySelectorAll('[data-tlr-drawer-close]').forEach(el => el.addEventListener('click', close));
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) close(); });
    }

    bindSearch() {
      const bar = this.querySelector('[data-tlr-search]');
      const trigger = this.querySelector('[data-tlr-search-open]');
      if (!bar || !trigger) return;

      const input = bar.querySelector('input[name="q"]');

      trigger.addEventListener('click', e => {
        e.preventDefault();
        bar.hidden = !bar.hidden;
        if (!bar.hidden && input) input.focus();
      });

      const close = () => {
        bar.hidden = true;
        // Clear the predictive results panel so stale hits aren't there on reopen.
        const results = bar.querySelector('#predictive-search');
        if (results) results.innerHTML = '';
      };

      bar.querySelector('[data-tlr-search-close]').addEventListener('click', close);
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && !bar.hidden) close(); });
      // Click outside the search row closes it.
      document.addEventListener('click', e => {
        if (bar.hidden || bar.contains(e.target) || trigger.contains(e.target)) return;
        close();
      });
    }

    /*
      Bag count. The count element also carries `.js-cart-count`, which is the selector the
      theme's own cart.js updates after an AJAX add — so in the normal case this needs to do
      nothing. These listeners only cover apps that fire a cart event without touching the
      DOM. We deliberately do NOT monkeypatch window.fetch: that wraps every request on the
      page and races with the theme's cart handling.
    */
    bindCartCount() {
      const el = this.querySelector('[data-tlr-cart-count]');
      if (!el) return;

      const refresh = () => {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart.js')
          .then(r => (r.ok ? r.json() : null))
          .then(cart => { if (cart) el.textContent = cart.item_count; })
          .catch(() => {});
      };

      ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart:updated'].forEach(evt =>
        document.addEventListener(evt, refresh)
      );
    }
  }

  if (!customElements.get('tlr-header')) customElements.define('tlr-header', TlrHeader);
})();

/*
  PDP Apple Pay express (see snippets/product-buttons.liquid). Shopify's dynamic
  checkout button shows Shop Pay to recognised Shop Pay users, so Apple-Pay-capable
  devices also get a native Apple Pay button — revealed only when Shopify's own
  button chose a different wallet (its <shopify-accelerated-checkout> element carries
  the choice in its `recommended` attribute, re-checked while it hydrates). Tapping
  adds the form's variant via AJAX (buyer's cart is kept, unlike a /cart permalink)
  and goes to checkout, where the Apple Pay sheet is the top express option.
*/
(function () {
  try {
    if (!(window.ApplePaySession && ApplePaySession.canMakePayments())) return;
  } catch (e) { return; }

  const sync = () => {
    document.querySelectorAll('[data-tlr-apple-express]').forEach(btn => {
      const sac = btn.closest('form')?.querySelector('shopify-accelerated-checkout');
      const rec = (sac && sac.getAttribute('recommended')) || '';
      btn.hidden = rec.includes('apple_pay');
    });
  };
  sync();
  let n = 0;
  const t = setInterval(() => { sync(); if (++n >= 6) clearInterval(t); }, 700);

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-tlr-apple-express]');
    if (!btn) return;
    const form = btn.closest('form');
    const id = form?.querySelector('[name="id"]')?.value;
    if (!id) return;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    }).then(r => {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    }).catch(() => { btn.disabled = false; });
  });
})();

/*
  Cart wallet buttons: Apple Pay first (client ask, Oct 22 2026). Shopify renders
  the cart / drawer wallets through <shopify-accelerated-checkout-cart>, which
  projects each wallet element into a NAMED slot (slot="button-ShopPay",
  "button-ApplePay", ...) in its closed shadow tree, so neither CSS `order` nor DOM
  order can reorder them. Swapping the two elements' slot names puts the Apple Pay
  wallet in the first position while it keeps its own one-tap Apple Pay sheet. The
  observer re-applies the swap if Shopify re-renders or resets the attributes.
*/
(function () {
  const HOST = 'shopify-accelerated-checkout-cart';
  const FIRST = 'button-ShopPay';
  function fix(host) {
    const apple = host.querySelector(':scope > shopify-apple-pay-button');
    const shop = host.querySelector(':scope > shop-pay-wallet-button');
    if (!apple || !shop) return;
    const a = apple.getAttribute('slot'), s = shop.getAttribute('slot');
    if (!a || !s || a === s || a === FIRST) return;
    apple.setAttribute('slot', s);
    shop.setAttribute('slot', a);
  }
  function scan() { document.querySelectorAll(HOST).forEach(fix); }
  try {
    new MutationObserver(scan).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['slot'],
    });
  } catch (e) { /* no observer: the load-time scan below still runs */ }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  scan();
})();

/* Quicknav inline accordion */
/* Quicknav inline accordion */
(function () {
  var nav = document.querySelector('[data-tlr-quicknav]');
  if (!nav) return;

  function trigger(panel) {
    return nav.querySelector('[data-tlr-qn-toggle="' + panel.dataset.tlrQnPanel + '"]');
  }

  function openPanel(panel, instant) {
    panel.hidden = false;
    if (instant) {
      panel.classList.add('is-instant');
      panel.classList.add('is-open');
      void panel.offsetHeight;              // flush the frame
      panel.classList.remove('is-instant');
    } else {
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
    }
    var t = trigger(panel);
    if (t) t.setAttribute('aria-expanded', 'true');
  }

  function closePanel(panel, instant) {
    var t = trigger(panel);
    if (t) t.setAttribute('aria-expanded', 'false');

    if (instant) {
      panel.classList.add('is-instant');
      panel.classList.remove('is-open');
      panel.hidden = true;
      void panel.offsetHeight;
      panel.classList.remove('is-instant');
      return;
    }

    panel.classList.remove('is-open');
    var done = function (e) {
      if (e.target !== panel) return;       // ignore bubbled child transitions
      panel.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
  }

  function openOne() {
    return nav.querySelector('.tlr-quicknav__panel.is-open');
  }

  nav.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tlr-qn-toggle]');
    if (!t) return;

    var panel = nav.querySelector('[data-tlr-qn-panel="' + t.getAttribute('data-tlr-qn-toggle') + '"]');
    if (!panel) return;                     // no panel — let it navigate

    e.preventDefault();

    var current = openOne();

    if (current === panel) { closePanel(panel, false); return; }

    if (current) {                          // swap: no collapse/expand jitter
      closePanel(current, true);
      openPanel(panel, true);
    } else {
      openPanel(panel, false);
    }
  });

  document.addEventListener('click', function (e) {
    if (nav.contains(e.target)) return;
    var current = openOne();
    if (current) closePanel(current, false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var current = openOne();
    if (current) { closePanel(current, false); var t = trigger(current); if (t) t.focus(); }
  });
})();